import React from 'react'

import AbsolutePageTemplate from '../../../../components/templates/AbsolutePageTemplate'
import PageContent from '../_shared/PageContent'
import PageHeader from '../_shared/PageHeader'
import ServiceOrderLoader from '../_load/ServiceOrderLoader'
import BrotherServiceOrderLoader from '../_load/BrotherServiceOrderLoader'

const TemplatePropostaManualPdfPage = ({ id, templateId }) => {
  return (
    <AbsolutePageTemplate>
      <ServiceOrderLoader id={id}>
        <BrotherServiceOrderLoader>
          <PageHeader templateId={parseInt(templateId)} />
          <PageContent />
        </BrotherServiceOrderLoader>
      </ServiceOrderLoader>
    </AbsolutePageTemplate>
  )
}

export default TemplatePropostaManualPdfPage
